import useValidation from "../../hooks/useValidation";
import { useEffect, useState } from "react";
import { format, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { DurationManagementType } from "../../static/types/commonTypes/durationManagementType";
import durationValidationSchema from "../../utils/validation/durationValidationSchema";

type durationProps = {
    dateLabelDébut: string,
    durationNatureOptions: string[],
    checkedduration: boolean,
    duration: DurationManagementType,
    changeDuration: (decision: Partial<DurationManagementType>) => void,
    onValidationChangeDuration: (isValid: boolean) => void
};

export default function DurationManagement({
    checkedduration,
    duration,
    durationNatureOptions,
    dateLabelDébut,
    changeDuration,
    onValidationChangeDuration
}: durationProps) {

    const { errors, isValid: isDataValid } = useValidation(duration, durationValidationSchema);

    useEffect(() => {
        onValidationChangeDuration(isDataValid);
    }, [isDataValid, onValidationChangeDuration]);

    useEffect(() => {
        changeDuration({ ...duration, DurationNature: durationNatureOptions[0] });
    }, []);

    const [selectedDecisionDateDébut, setSelectedDecisionDateDébut] = useState<string>("");
    const [selectedEffectiveDateFin, setSelectedEffectiveDateFin] = useState<string>("");

    useEffect(() => {
        if (duration.DurationDateDébut) {
            const parsedDate = parse(duration.DurationDateDébut, "dd/MM/yyyy", new Date());
            setSelectedDecisionDateDébut(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
        if (duration.DurationDateFin) {
            const parsedDate = parse(duration.DurationDateFin, "dd/MM/yyyy", new Date());
            setSelectedEffectiveDateFin(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [duration]);

    const handleDecisionDateChangeDébut = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = format(parsedDate, "dd/MM/yyyy");

        setSelectedDecisionDateDébut(inputDate);
        changeDuration({ DurationDateDébut: isValid(parsedDate) ? formattedDate : "" });
    };

    const handleEffectiveDateChangeFin = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = format(parsedDate, "dd/MM/yyyy");

        setSelectedEffectiveDateFin(inputDate);
        changeDuration({ DurationDateFin: isValid(parsedDate) ? formattedDate : "" });
    };

    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (
        <div className="mb-3 row">



            <div className="mb-3 row">
                <label htmlFor="dateLabelDébut" className="col-sm-2 col-form-label">
                    {dateLabelDébut} <strong className="text-danger">*</strong>
                </label>

                <div className="col-sm-4 mb-3">
                    <input
                        className={`description-input form-control ${(checkedduration && errors.DurationDateDébut) ? 'is-invalid' : ''}`}
                        type="date"
                        id="DurationDateDébut"
                        value={selectedDecisionDateDébut}
                        onChange={handleDecisionDateChangeDébut}
                        onClick={() => openDatePicker("DurationDateDébut")}
                        placeholder="JJ/MM/AAAA"
                    />
                    {(checkedduration && errors.DurationDateDébut) && (
                        <div className="invalid-feedback">{errors.DurationDateDébut}</div>
                    )}
                </div>
            </div>


            <div className="mb-3 row">
                <label htmlFor="DurationDateFin" className="col-sm-2 col-form-label">Date de fin <strong className="text-danger">*</strong></label>
                <div className="col-sm-4 mb-3">
                    <input
                       className={` form-control ${(checkedduration && errors.DurationDateFin) ? 'is-invalid' : ''}`}
                        type="date"
                        id="DurationDateFin"
                        value={selectedEffectiveDateFin}
                        onChange={handleEffectiveDateChangeFin}
                        onClick={() => openDatePicker("DurationDateFin")}
                        placeholder="JJ/MM/AAAA"
                    />
                     {(checkedduration && errors.DurationDateFin) && (
                        <div className="invalid-feedback">{errors.DurationDateFin}</div>
                    )}
                </div>
            </div>


            <div className="mb-3 row">
                <label htmlFor="decisionNature" className="col-sm-2 col-form-label">
                    Renouvellement
                </label>

                <div className="col-sm-4 mb-3">
                    <select
                        className="form-select"
                        id="decisionNature"
                        onChange={event => changeDuration({ DurationNature: event.target.value })}
                        value={duration.DurationNature}
                    >
                        {durationNatureOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
